import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WebLayout from "../../../layout/WebLayout";
import { RootState } from "../../../stores";
import POProductAction from "../../../stores/actions/POProductAction";
import { useParams } from "react-router-dom";
import POAddToCart from "../../../components/POAddToCart";
import { toast } from "react-toastify";
import UpdateDeliveryCharhe from "../../../components/UpdateDeliveryCharge";
import UpdateLandingCost from "../../../components/UpdateLandingCost";

const PoOrderItems = () => {
  const dispatch = useDispatch<any>();

  const routeParams = useParams();
  const id = routeParams.id;

  const { poOrderItemList } = useSelector(
    (state: RootState) => state.po_product
  );

  const [loader, setLoader] = useState<boolean>(false);
  const [search, setSearch] = useState<any>("");
  const [hit, setHit] = useState<any>(0);
  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const getPOProductList = useCallback(async () => {
    await dispatch(POProductAction.getPOOrderItems({ id: id }));
  }, [dispatch, search, hit]);

  const acceptReject = async (status: any) => {
    if (window.confirm("Are you sure you want to accept the order?")) {
      setLoader(true);
      try {
        await dispatch(
          POProductAction.acceptReject({
            id: poOrderItemList.poOrders.id,
            status: status,
            without_margin_price: poOrderItemList?.total,
            price: poOrderItemList?.totalWithMarginPrice,
            tax: poOrderItemList?.totalTax,
            qty: poOrderItemList?.totalSupplyQty,
          })
        );
        setLoader(false);
        window.location.reload();
      } catch (e: any) {
        setLoader(false);
        toast.error(e.message);
      }
    }
  };

  const cancelOrderItem = async (id: number) => {
    if (window.confirm("Are you sure you want to cancel the order item?")) {
      setLoader(true);
      try {
        await dispatch(
          POProductAction.CancleOrderItemStatus({
            id: id,
          })
        );
        setLoader(false);
        getPOProductList();
      } catch (e: any) {
        setLoader(false);
        toast.error(e.message);
      }
    }
  };

  useEffect(() => {
    getPOProductList();
  }, [getPOProductList, search]);

  return (
    <WebLayout pageName={"PoOrderItems"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="card">
            <h5 className="card-header d-flex justify-content-between">
              <h5>PO ORDER ITEMS</h5>
            </h5>
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h6 className="pb-0 mb-2">Purchase Order From</h6>
                  <p className="mb-1">
                    <b>{poOrderItemList.userDetails.name_of_entity}</b>
                  </p>
                  <p className="mb-1">
                    <b>Address</b> {poOrderItemList.userDetails.address}
                  </p>
                  <p className="mb-1">
                    <b>Mobile No.</b> {poOrderItemList.userDetails.mobile}
                  </p>
                  <p className="mb-0">
                    <b>Email</b> {poOrderItemList.userDetails.email}
                  </p>
                  <p className="mb-0">
                    <b>GST</b> {poOrderItemList.userDetails.gst_no}
                  </p>
                </div>

                <div>
                  <h6 className="pb-0 mb-2">Purchase Order Through</h6>
                  <p className="mb-1">
                    <b>Abhhyam Marketing India Pvt. Ltd.</b>
                  </p>
                  <p className="mb-1">
                    <b>Address</b> Office: No. 82, Block -C, Pocket -7, Sector
                    8, Rohini, New Delhi 110085
                  </p>
                  <p className="mb-1">
                    <b>Mobile No.</b> +91-9990060531
                  </p>
                  <p className="mb-0">
                    <b>Email</b> abhhyamtrading@gmail.com
                  </p>
                  <p className="mb-0">
                    <b>GST</b> 07AAZCA3735E1ZF
                  </p>
                </div>
              </div>

              {poOrderItemList.data?.length > 0 ? (
                <div className="card-datatable table-responsive mt-3">
                  <table className="dt-advanced-search table border-top">
                    <thead>
                      <tr>
                        <th>Product Name</th>
                        <th>Product Code</th>
                        <th>Landing Cost</th>
                        <th>Tax %</th>
                        <th>Tax Amount</th>
                        <th>Total Amount</th>
                        {poOrderItemList?.poOrders?.po_order_status ===
                        "REQUESTED" ? (
                          <th>Action</th>
                        ) : (
                          <th>Qty</th>
                        )}
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {poOrderItemList.data.map((data: any) => {
                        return (
                          <tr>
                            <td>{data.product_name}</td>
                            <td>{data.product_code}</td>
                            <td>
                              <UpdateLandingCost
                                proId={data.id}
                                landingCostAmount={data.landing_cost}
                                getPOProductList={getPOProductList}
                              />
                            </td>
                            <td>{data.productTax} %</td>
                            <td>Rs. {data?.rowTax?.toFixed(2)}</td>
                            <td>Rs. {data?.rowPrice?.toFixed(2)}</td>
                            {poOrderItemList?.poOrders?.po_order_status ===
                            "REQUESTED" ? (
                              <td>
                                <POAddToCart
                                  productId={data.id}
                                  cartQty={data.supply_qty}
                                  qty={data.qty}
                                  rowAmount={data.rowPrice}
                                  rowTax={data.rowTax}
                                  minSaleQty={data.min_sale_qty}
                                  getPOProductList={getPOProductList}
                                  id={id}
                                  hit={hit}
                                  setHit={setHit}
                                />
                              </td>
                            ) : (
                              <td>{data.supply_qty}</td>
                            )}
                            <td>
                              {data.cancel_status == 0 ? (
                                <button
                                  onClick={() => cancelOrderItem(data.id)}
                                  className="btn btn-sm btn-warning text-dark">
                                  Cancel
                                </button>
                              ) : (
                                <button className="btn btn-sm btn-danger">
                                  Cancelled
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="row">
                    <div className="col-lg-9"></div>
                    <div className="col-lg-3">
                      <table className="table">
                        <tbody>
                          <tr>
                            <th>Sub Total</th>
                            <td>Rs. {poOrderItemList?.total?.toFixed(2)}</td>
                          </tr>
                          <tr>
                            <th>Delivery Charge</th>
                            <td>
                              <UpdateDeliveryCharhe
                                poOrderId={poOrderItemList?.poOrders?.id}
                                deliveryChargeAmount={
                                  poOrderItemList?.poOrders?.delivery_charge
                                }
                                getPOProductList={getPOProductList}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Grand Total</th>
                            <td>
                              Rs. {poOrderItemList?.grandTotal?.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {poOrderItemList?.poOrders?.po_order_status ===
                      "ACCEPTED" ? (
                        <button className="btn btn-success btn-sm mt-3">
                          ACCEPTED
                        </button>
                      ) : poOrderItemList?.poOrders?.po_order_status ===
                        "REJECTED" ? (
                        <button className="btn btn-danger btn-sm mt-3">
                          REJECTED
                        </button>
                      ) : (
                        <>
                          <button
                            className="btn btn-success btn-sm mt-3"
                            onClick={() => acceptReject("ACCEPTED")}>
                            Accept
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger btn-sm mt-3"
                            onClick={() => acceptReject("REJECTED")}>
                            Reject
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {/*)}*/}
        </div>
      </div>
    </WebLayout>
  );
};

export default PoOrderItems;
